export const pxTalkLevelTypes = {
    price: { key: 1, title: 'Price' },
    DM: { key: 2, title: 'DM' }
};
